import { useEffect, useState } from 'react';
import Welcome from './Welcome';
import MessageList from './chat-history/MessageList';
import SettingsBar from './SettingsBar';
import ChatInput from './ChatInput';
import { observer } from 'mobx-react-lite';
import { HelperCore } from "@/common/helper";
import wsStore from '@/components/chat-ws/store';
import './index.scss';
import { SVGPureIcon } from '@/ui';

function Chat(props) {
  const store = wsStore.currentStore || {};
  const { messageList, canAborting, isAITyping } = store;

  return (
    <div
      className={[
        'relative',
        'size-full overflow-hidden',
        'flex flex-col items-center',
        'text-black',
      ]}
    >
      {messageList?.length > 0 ? (
        <MessageList items={messageList} />
      ) : (
        <div className="w-full h-0 flex-grow overflow-y-auto px-[16px] flex justify-center">
          <Welcome className="" />
        </div>
      )}

      <div className="w-full flex justify-center">
        <section
          style={{
            background: 'linear-gradient(180deg,rgba(249,250,251,0) 0%,#F2F3F5 100%)',
          }}
          className={[
            'relative',
            'w-full',
            'px-[16px] py-[12px]',
            'flex flex-col items-center gap-[8px]',
            'bg-white',
          ]}
        >
          {canAborting && isAITyping && (
            <StopButton
              className={[
                'absolute',
                '-top-[4px] transform -translate-y-full',
                'left-1/2 -translate-x-1/2',
              ]}
              onClick={
                () => {
                  store.log({
                    action : "click",
                    arrt : "aibot_plugin_sidebar_stop",
                    message_id : store.lastMessage.msg_id,
                    role_id : store.lastMessage.role_id,
                  });
                  store.abort();
                }
              }
            />
          )}

          <SettingsBar />
          <ChatInput
            className="size-full"
            disabled={isAITyping}
            onSend={({ value }) => {
              wsStore.sendMessage({ input: value });
            }}
          />
          <span className="text-[12px] text-black text-opacity-30 select-none">
            以上内容均由AI大模型生成，仅供参考
          </span>
        </section>
      </div>
    </div>
  );
}

function StopButton({ className, onClick }) {
  return (
    <button
      className={[
        'group',
        'absolute',
        'transform',
        '-top-10px -translate-y-full',
        'left-1/2 -translate-x-1/2',
        'rounded-[8px] border-1px border-black-10',
        'pl-[10px] pr-[14px] py-6px',
        'flex gap-6px',
        'bg-button-bg-normal',
        className
      ]}
      onClick={event => onClick?.(event)}
    >
      <SVGPureIcon
        name="competitive-chat-stop"
        className="size-20px text-opacity-50 text-primary-opacity group-hover:text-opacity-80"
      />
      <div className="text-[14px] leading-[20px] text-primary-opacity text-opacity-50 group-hover:text-opacity-80">
        停止
      </div>
    </button>
  );
}

const ChatWSComponent = observer(Chat);
export default ChatWSComponent;
